import { render } from "./TaxRateItem.vue?vue&type=template&id=4eb3b147&scoped=true"
import script from "./TaxRateItem.vue?vue&type=script&lang=js"
export * from "./TaxRateItem.vue?vue&type=script&lang=js"

import "./TaxRateItem.vue?vue&type=style&index=0&id=4eb3b147&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb3b147"]])

export default __exports__